import { createContext } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AddDevicesModal,
  BpTypeModal,
  ContactSupportModal,
  CreateUserModal,
  DeleteUserModal,
  EditAccountModal,
  FeatureFeedbackModal,
  InvitePatientModal,
  LearnMoreAboutCuffModal,
  LearnMoreModal,
  OrderDevicesModal,
  RemoveDeviceModal,
  SendFeedbackModal,
} from '../../components/app';
import { ChangeUserRoleModal } from '../../components/app/modals/change-user-role';
import { ModalName } from '../../enums';
import { useIsModalOpened } from '../../features/modals';
import { IModalsProviderProps } from './types';

export const ModalsContext = createContext(null);

export const ModalsProvider = ({ children }: IModalsProviderProps) => {
  const { t } = useTranslation();

  return (
    <ModalsContext.Provider value={null}>
      {useIsModalOpened(ModalName.ADD_DEVICES) && <AddDevicesModal />}
      {useIsModalOpened(ModalName.AKTIIA_STATUS) && (
        <BpTypeModal name={ModalName.AKTIIA_STATUS} title={t('modal.bpType.title.aktiiaStatus')} />
      )}
      {useIsModalOpened(ModalName.BP_CLASS) && (
        <BpTypeModal name={ModalName.BP_CLASS} title={t('modal.bpType.title.bpClass')} />
      )}
      {useIsModalOpened(ModalName.CHANGE_USER_ROLE) && <ChangeUserRoleModal />}
      {useIsModalOpened(ModalName.CONTACT_SUPPORT) && <ContactSupportModal />}
      {useIsModalOpened(ModalName.CREATE_USER) && <CreateUserModal />}
      {useIsModalOpened(ModalName.DELETE_USER) && <DeleteUserModal />}
      {useIsModalOpened(ModalName.EDIT_ACCOUNT) && <EditAccountModal />}
      {useIsModalOpened(ModalName.FEATURE_FEEDBACK) && <FeatureFeedbackModal />}
      {useIsModalOpened(ModalName.INVITE_PATIENT) && <InvitePatientModal />}
      {useIsModalOpened(ModalName.LEAR_MORE) && <LearnMoreModal />}
      {useIsModalOpened(ModalName.LEAR_MORE_ABOUT_CUFF) && <LearnMoreAboutCuffModal />}
      {useIsModalOpened(ModalName.ORDER_DEVICES) && <OrderDevicesModal />}
      {useIsModalOpened(ModalName.REMOVE_DEVICE) && <RemoveDeviceModal />}
      {useIsModalOpened(ModalName.SEND_FEEDBACK) && <SendFeedbackModal />}

      {children}
    </ModalsContext.Provider>
  );
};
